window.addEventListener("DOMContentLoaded", (event) => {
  $(document).on("click", ".header_content_mobile .menu_mobile_menu", function(event) {
    $(this).toggleClass("active");
    $('.mobile-menu').toggleClass('is-show');
    $('.mobile-menu_container').toggleClass('is-show');
    $("body").css("overflow", "hidden");
  });
  $(document).on("click", ".mobile-menu", function(e) {
    if (!$(".mobile-menu_container").is(e.target) && $(this).has(e.target).length === 0) {
      $(".mobile-menu.is-show").removeClass("is-show");
      $('.mobile-menu_container').removeClass('is-show');
      $("body").css("overflow", "auto");
    }
  });
});
